{
  "clw-prod": {
    "firebaseConfig": {
      "apiKey": "AIzaSyAfOngIGp7-rCSuwnehrWDI5_gbNw3G06s",
      "authDomain": "clw.syncretic.work",
      "projectId": "syncretic-clw-01",
      "storageBucket": "syncretic-clw-01.firebasestorage.app",
      "messagingSenderId": "748763423023",
      "appId": "1:748763423023:web:7bd587a63b50beacad81da"
    },
    "cloudRunURLs": {
      "runLanguageModel": "https://runlanguagemodel-748763423023.us-central1.run.app/runlanguagemodel"
    },
    "algoliaConfig": {
      "local": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "691a3087ebd860db4b468e62b967e423",
        "allIndexName": "local_SEARCH_INDEX"
      },
      "cloud": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "073b2aa9884b5d0afd9a8aa28431050a",
        "allIndexName": "syncretic-clw-01_SEARCH_INDEX"
      }
    },
    "usersnapSpaceId": "90c72e4b-72e7-46da-8a23-0c0ac109027b",
    "googleMapsApiKey": "AIzaSyA3tEvlyW3esvIT-q9G2_VbQ3K5xcBVQGg",
    "posthogConfig": {
      "posthogApiKey": "phc_jr2YRrfoTZi5jokVVCYeqBtMiQoJpRw3IlGsTMmDCGc",
      "posthogHost": "https://t.syncretic.work",
      "posthogDebug": "false",
      "disableTelemetry": "false"
    },
    "mcpOAuthEnabled": true
  },
  "dev": {
    "firebaseConfig": {
      "apiKey": "AIzaSyAJg2nu00eKHxFaGiX3ftIPLpI1bxPPNSo",
      "authDomain": "dev.syncretic.cc",
      "projectId": "syncretic-prototype-01-dev",
      "storageBucket": "syncretic-prototype-01-dev.firebasestorage.app",
      "messagingSenderId": "455859974342",
      "appId": "1:455859974342:web:e3222c277b22a17ca6a7c7"
    },
    "cloudRunURLs": {
      "runLanguageModel": "https://runlanguagemodel-455859974342.us-central1.run.app/runlanguagemodel"
    },
    "algoliaConfig": {
      "local": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "691a3087ebd860db4b468e62b967e423",
        "allIndexName": "local_SEARCH_INDEX"
      },
      "cloud": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "691a3087ebd860db4b468e62b967e423",
        "allIndexName": "syncretic-prototype-01-dev_SEARCH_INDEX"
      }
    },
    "usersnapSpaceId": "90c72e4b-72e7-46da-8a23-0c0ac109027b",
    "googleMapsApiKey": "AIzaSyB6cCrECkJmVwhC6zgcdY5d_mRHK35gRXQ",
    "posthogConfig": {
      "posthogApiKey": "phc_TUBOUS0Pg08Zxkr9U1OLNRY0h3H34U77960KWvXU70P",
      "posthogHost": "https://t.syncretic.work",
      "posthogDebug": "false",
      "disableTelemetry": "true"
    },
    "mcpOAuthEnabled": true
  },
  "proto": {
    "firebaseConfig": {
      "apiKey": "AIzaSyC_8lGDjHSKFqSqaYGvU5cP4JwZ_xnPTAs",
      "authDomain": "prototype.syncretic.cc",
      "projectId": "syncretic-prototype-01",
      "storageBucket": "syncretic-prototype-01.firebasestorage.app",
      "messagingSenderId": "317167905555",
      "appId": "1:317167905555:web:5df35becbdd44c176f48e6"
    },
    "cloudRunURLs": {
      "runLanguageModel": "https://runlanguagemodel-317167905555.us-central1.run.app/runlanguagemodel"
    },
    "algoliaConfig": {
      "local": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "691a3087ebd860db4b468e62b967e423",
        "allIndexName": "local_SEARCH_INDEX"
      },
      "cloud": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "073b2aa9884b5d0afd9a8aa28431050a",
        "allIndexName": "syncretic-prototype-01_SEARCH_INDEX"
      }
    },
    "usersnapSpaceId": "90c72e4b-72e7-46da-8a23-0c0ac109027b",
    "googleMapsApiKey": "AIzaSyA3tEvlyW3esvIT-q9G2_VbQ3K5xcBVQGg",
    "posthogConfig": {
      "posthogApiKey": "phc_fI9s63SK9KQfc4sdyXhswiT9rizybHXR3AH1qyNpM1q",
      "posthogHost": "https://t.syncretic.work",
      "posthogDebug": "false",
      "disableTelemetry": "true"
    },
    "mcpOAuthEnabled": true
  },
  "prod": {
    "firebaseConfig": {
      "apiKey": "AIzaSyD7F99tT1Pg5rBaw06xY50SjSj0WWeEREQ",
      "authDomain": "system.syncretic.cc",
      "projectId": "syncretic-system",
      "storageBucket": "syncretic-system.firebasestorage.app",
      "messagingSenderId": "889882364138",
      "appId": "1:889882364138:web:96db37568d25d6bc98af93"
    },
    "cloudRunURLs": {
      "runLanguageModel": ""
    },
    "algoliaConfig": {
      "local": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "073b2aa9884b5d0afd9a8aa28431050a",
        "allIndexName": "local_SEARCH_INDEX"
      },
      "cloud": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "073b2aa9884b5d0afd9a8aa28431050a",
        "allIndexName": "syncretic-system_SEARCH_INDEX"
      }
    },
    "usersnapSpaceId": "90c72e4b-72e7-46da-8a23-0c0ac109027b",
    "googleMapsApiKey": "AIzaSyB6cCrECkJmVwhC6zgcdY5d_mRHK35gRXQ",
    "posthogConfig": {
      "posthogApiKey": "phc_LhVkuCHy1mRadNzRhlvG1gOLz7TeMY4YMQWO4ChjUOH",
      "posthogHost": "https://t.syncretic.work",
      "posthogDebug": "false",
      "disableTelemetry": "false"
    },
    "mcpOAuthEnabled": true
  },
  "local": {
    "firebaseConfig": {
      "apiKey": "AIzaSyAJg2nu00eKHxFaGiX3ftIPLpI1bxPPNSo",
      "authDomain": "demo-syncretic.firebaseapp.com",
      "projectId": "demo-syncretic",
      "storageBucket": "demo-syncretic.appspot.com"
    },
    "cloudRunURLs": {
      "runLanguageModel": "http://localhost:8081/runlanguagemodel"
    },
    "algoliaConfig": {
      "local": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "691a3087ebd860db4b468e62b967e423",
        "allIndexName": "local_SEARCH_INDEX"
      },
      "cloud": {
        "appId": "O0ZC7T5GL4",
        "searchApiKey": "691a3087ebd860db4b468e62b967e423",
        "allIndexName": "local_SEARCH_INDEX"
      }
    },
    "usersnapSpaceId": "90c72e4b-72e7-46da-8a23-0c0ac109027b",
    "googleMapsApiKey": "AIzaSyB6cCrECkJmVwhC6zgcdY5d_mRHK35gRXQ",
    "posthogConfig": {
      "posthogApiKey": "phc_TUBOUS0Pg08Zxkr9U1OLNRY0h3H34U77960KWvXU70P",
      "posthogHost": "https://t.syncretic.work",
      "posthogDebug": "false",
      "disableTelemetry": "true"
    },
    "mcpOAuthEnabled": false
  }
}